import axios from 'axios'
import moment from 'moment'
import Vue from 'vue'
import api from "../../api";

const state = {
    meal_types: null,
    challenge: null,
    meal_plan_items: [],
    editing: null,
    current_week: 1,
    inline: false,
    token: {action: null}
}

const mutations = {
    MEAL_TYPES (state, value) {
        state.meal_types = value
    },
    SET_CHALLENGE (state, value) {
        state.challenge = value
    },
    SET_MEAL_PLAN_ITEMS (state, value) {
        state.meal_plan_items = value
    },
    ADD_MEAL_PLAN_ITEM (state, value) {
        state.meal_plan_items.push(value)
    },
    SET_EDITING (state, value) {
        if (state.editing && (!state.editing.recipe && !state.editing.meal)) {
            // state.meal_plan_items.splice(state.meal_plan_items.indexOf(state.editing), 1)
        }
        state.editing = value
    },
    UPDATE_EDITING (state, value) {
        if (state.editing && state.editing.recipe) {
            state.editing.recipe = value
        }
        if (state.editing && state.editing.meal) {
            state.editing.meal = value
        }
    },
    SET_MEAL (state, value) {
        let meal = state.meal_plan_items.filter(item => {
            return (item.day === value.day && item.stream === value.stream && item.meal_type_id === value.meal_type_id)
        })
        meal = (meal.length > 0) ? meal[0] : null
        let index = state.meal_plan_items.indexOf(meal)
        if(index > -1) {
            Vue.set(state.meal_plan_items, index, value)
            state.editing = state.meal_plan_items[index]
        }


    },
    SET_CURRENT_WEEK (state, value) {
        state.current_week = value
    },
    SET_INLINE (state, value) {
        state.inline = value
    },
    UPDATE_MEAL_ITEM (state, value) {
        let index = state.meal_plan_items.indexOf(value.item)
        if( index >= 0) {
            Vue.set(state.meal_plan_items[index], 'claimed', value.action === 'add' ? true : false)
        }
    },
    SET_TOKEN (state, value) {
        state.token = value
    }
}

const actions = {
    setMealTypes ({commit, dispatch}, value) {
        commit('MEAL_TYPES', value)
    },
    setInline ({commit, dispatch}, value) {
        commit('SET_INLINE', value)
    },
    setChallenge ({commit, dispatch, state}, value) {
        commit('SET_CHALLENGE', value)
        if (state.inline) dispatch('loadMealPlan', state.challenge.id)
    },
    setMealPlanItems ({commit, dispatch}, value) {
        commit('SET_MEAL_PLAN_ITEMS', value)
    },
    async loadMealPlan ({state, rootState, dispatch, commit}, challenge_id) {
        if(!challenge_id && state.challenge) challenge_id = state.challenge.id
        if(!challenge_id) return
        if(!state.meal_types) await dispatch('loadChallenge', challenge_id)
        dispatch('Global/setLoading', true, {root: true})
        axios.post(rootState.Settings.apiUrl + '/mealplan/load', {challenge_id: challenge_id, week: state.current_week})
            .then(function (response) {
                dispatch('Global/setLoading', false, {root: true})
                dispatch('setMealPlanItems', response.data)
            })
    },
    async loadChallenge ({state, rootState, dispatch, commit}, challenge_id) {
        axios.post(rootState.Settings.apiUrl + '/mealplan/load-challenge', {challenge_id: challenge_id})
            .then(function (response) {
                let challenge = Object.assign({}, response.data.challenge)
                dispatch('setMealTypes', response.data.meal_types)
                dispatch('setChallenge', challenge)
            })
    },
    editMealItem ({commit}, value) {
        commit('SET_EDITING', value)
    },
    editMeal ({commit}, value) {
        value.editing = true
        commit('SET_MEAL', value)
    },
    cancelEditMeal ({commit}, value) {
        value.editing = false
        commit('SET_MEAL', value)
    },
    addMeal ({commit}, item) {
        commit('ADD_MEAL_PLAN_ITEM', item)
        commit('SET_EDITING', item)
    },
    saveMeal ({commit, state, rootState, dispatch}) {
        dispatch('Global/setSaving', true, {root: true})
        let meal = {
            challenge_id: state.challenge.id,
            day: state.editing.day,
            stream: rootState.Streams.stream.id,
            meal_type_id: state.editing.meal_type_id,
            recipe: state.editing.recipe,
            meal: state.editing.meal
        }
        axios.post(rootState.Settings.apiUrl + '/mealplan/save-meal', meal)
            .then(async function (response) {
                if (state.editing.editing) {
                    response.data.editing = true
                }
                commit('SET_MEAL', response.data)
                // TODO: why load challenge?
                // commit('SET_EDITING', null)
                // await dispatch('loadMealPlan', state.challenge.id)
                dispatch('Global/setSaving', false, {root: true})

            })
    },
    deleteMeal ({commit, state, rootState, dispatch}, value) {
        axios.delete(rootState.Settings.apiUrl + '/mealplan/delete-meal/' + value.id)
            .then(function (response) {
                commit('SET_MEAL', response.data)
                dispatch('loadMealPlan', state.challenge.id)
            })
    },
    excludeMealFromShopping ({commit, state, rootState, dispatch}, meal) {
        axios.post(rootState.Settings.apiUrl + '/mealplan/exclude-meal-from-shopping', {id: meal.id, exclude: meal.exclude})
            .then(function (response) {

            })
            .catch(function (error) {
            })
    },
    setCurrentWeek ({commit, dispatch, state}, value) {
        commit('SET_CURRENT_WEEK', value)
        // used for both admin and app so..
        if (state.inline) dispatch('loadMealPlan', state.challenge.id)
    },
    setEditing ({commit, rootState, state}, data) {
        commit('SET_EDITING', data)
    },
    updateMealToken ({commit, rootState, state}, data) {
        commit('UPDATE_MEAL_ITEM', data)
    },
    setToken ({commit}, data) {
        commit('SET_TOKEN', data)
    },
    updateEditing ({commit, state, rootState}) {
        if(!state.editing) return
        let value = null
        if(state.editing.recipe) {
            value = rootState.Recipe
        }
        if(state.editing.meal) {
            value = rootState.Meal
        }
        commit('UPDATE_EDITING', value)
    }
}

const getters = {
    meal_types: (state) => {
        return state.meal_types
    },
    challenge: (state) => {
        return state.challenge
    },
    meal_plan_items: (state) => {
        return state.meal_plan_items
    },
    weeks (state) {
        if(!state.challenge) return 0

        var start = moment(state.challenge.start_date, 'DD/MM/YYYY')
        var end = moment(state.challenge.end_date, 'DD/MM/YYYY').add(1, 'days')
        return end.diff(start, 'week')
    },
    meal: (state, getters, rootState) => (week, day, meal_type_id) => {
        let total_day = (week - 1) * 7 + day
        let stream = rootState.Streams.stream.id
        let meal = state.meal_plan_items.filter(meal_plan => {
            return parseInt(meal_plan.day) === parseInt(total_day)
                && parseInt(meal_plan.meal_type_id) === parseInt(meal_type_id)
                && (parseInt(meal_plan.stream) === stream || parseInt(meal_plan.stream) === 0)
        })
        meal = meal.sort((a,b) => (a.stream > b.stream) ? -1 : ((b.stream > a.stream) ? 1 : 0));
        return meal.length > 0 ? meal[0] : null
        // return total_day + ' ' + meal_type_id
    },
    editing: (state) => state.editing,
    currentWeek: (state) => state.current_week,
    day_nutrition: (state, getters, rootState) => (day, type) => {
        let result = 0
        let list = {}
        state.meal_plan_items.forEach(item => {
            if (item.day !== day) return
            if (item.stream !== 0 && item.stream !== rootState.Streams.stream.id) return
            list[item.day + '_' + item.meal_type_id] = item
        })

        Object.keys(list).forEach(key => {
            let item = list[key]
            if(item.meal && item.meal.ingredient_lists) {
                result += parseFloat(api.getTotalNutrition(type, item.meal.servings, item.meal.ingredient_lists, rootState.Streams.stream))
            } else if(item.recipe && item.recipe.ingredient_lists) {
                result += parseFloat(api.getTotalNutrition(type, item.recipe.servings, item.recipe.ingredient_lists, rootState.Streams.stream))
            }
        })

        if (type === 'calories') return result
        return parseFloat(result).toFixed(2)
    },
    meal_nutrition: (state, getters, rootState) => (item, type) => {
        let result = 0

        if(item.meal && item.meal.ingredient_lists) {
            result += parseFloat(api.getTotalNutrition(type, item.meal.servings, item.meal.ingredient_lists, rootState.Streams.stream))
        } else if(item.recipe && item.recipe.ingredient_lists) {
            result += parseFloat(api.getTotalNutrition(type, item.recipe.servings, item.recipe.ingredient_lists, rootState.Streams.stream))
        }

        if (type === 'calories') return result
        return parseFloat(result).toFixed(2)
    },
    meal_tokens: (state) => {
        let startDay = (state.current_week - 1) * 7 + 1
        let endDay = state.current_week * 7
        let claimed_meals = state.meal_plan_items.filter(item => {
            return item.claimed && item.day >= startDay && item.day <= endDay && item.meal_type.token_type == 'meal'
        })
        return claimed_meals
    },
    snack_tokens: (state) => {
        let startDay = (state.current_week - 1) * 7 + 1
        let endDay = state.current_week * 7
        let claimed_meals = state.meal_plan_items.filter(item => {
            return item.claimed && item.day >= startDay && item.day <= endDay && item.meal_type.token_type == 'snack'
        })
        return claimed_meals
    },
    token: (state) => state.token

}

export default {
    state,
    mutations,
    actions,
    getters,
    namespaced: true
}
